import React from "react";
import RichText from "@qlik/qlik/src/components/RichText";

const Popup = ({ data }) => {
    const popupData = { body: data?.content ?? null };
    return (
        <div>
            {data?.content?.raw && (
                <div
                    id={data.id}
                    className="hidden richtext-content px-3.75 py-7.5 rounded-sm relative popup-container"
                >
                    <RichText data={popupData} />
                </div>
            )}
        </div>
    );
};

export default Popup;
